import './tripInfo.css';
import video from '../../../assets/images/video-slider.jpg'
import DriverVideoSlider from "../driverVideoSlider/driverVideoSlider";

const TripInfo = () => {
    return(
        <>
            <div className="margin-b-20">
                <DriverVideoSlider/>
            </div>
            <div className="">
                <div className="sf-bold margin-b-5">BharathBenz HDT R  - 30 Tons   </div>
                <div className="sf-medium font-15">KA 02  N 9023   |   Model: 2017</div>
            </div>
        </>
    )
}

export default TripInfo;
